// React
import React, { useEffect, useState } from 'react';
// Locales
import translate from 'locales/i18n';
// Stores
import LoggedUserStore from 'stores/LoggedUserStore';
// Material components
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/lab/Pagination';
import { Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
// Style
import { useStyles } from 'components/page/CatalogPage/CatalogPage.style';
// Stores
import CatalogStore from 'stores/CatalogStore';
// Action
import CatalogAction from 'actions/CatalogAction';
// Theme
import theme from 'assets/theme/theme';
// Facade
import Facade from 'core/Facade';
// PCP Components
import DialogCatalogInfo from 'components/dialogs/catalog/DialogCatalogInfo/DialogCatalogInfo';
import Loader from 'components/commons/Loader';
import OnMousePopover from 'components/commons/OnMousePopover';

const CatalogPage = () => {
    const [loading, setLoading] = useState(CatalogStore.isLoading());
    const [catalogs, setCatalogs] = useState(CatalogStore.getCatalogs());
    const [params, setParams] = useState(CatalogStore.getParams());
    const [dialogInfo, setDialogInfo] = useState({ open: false, currentCatalog: null });
    const { page, rowsPerPage, site, account } = params;
    const classes = useStyles();

    useEffect(() => {
        CatalogStore.addChangeListener(onCatalogStoreChange);

        if (CatalogStore.getCatalogs().length === 0 && LoggedUserStore.isLogged()) CatalogAction.getCatalogs(params);

        return () => {
            CatalogStore.removeChangeListener(onCatalogStoreChange);
        };
    }, []);

    useEffect(() => {
        setLoading(true);
        CatalogAction.getCatalogs(params);
    }, [params]);

    const onCatalogStoreChange = () => {
        setLoading(CatalogStore.isLoading());
        setCatalogs(CatalogStore.getCatalogs());
    };

    return <div className={classes.root}>
        <div className={classes.topContainer}>
            <TextField
                onChange={event => {
                    const newParams = Object.assign({}, params);
                    newParams.site = event.target.value;
                    setParams(newParams);
                }}
                value={site}
                style={{ width: 300 }}
                label={translate.i18n('SITES')}
                variant='outlined'
                className={classes.formControl}
                size='small'
            />
            <TextField
                onChange={event => {
                    const newParams = Object.assign({}, params);
                    newParams.account = event.target.value;
                    setParams(newParams);
                }}
                value={account}
                style={{ width: 300 }}
                label={translate.i18n('ACCOUNTS')}
                variant='outlined'
                className={classes.formControl}
                size='small'
            />
        </div>
        {!loading ?
            <TableContainer component={Paper} className={classes.tableContainer}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{translate.i18n('DATE')}</TableCell>
                            <TableCell align='center' className={classes.headCell}>{translate.i18n('TAG')}</TableCell>
                            <TableCell align='center' className={classes.headCell}>{translate.i18n('SITES')}</TableCell>
                            <TableCell align='center' className={classes.headCell}>{translate.i18n('ACCOUNTS')}</TableCell>
                            <TableCell align='center' className={classes.headCell}>{translate.i18n('IDENTIFIED_CATEGORIES')}</TableCell>
                            <TableCell align='center' className={classes.headCell}>{translate.i18n('IDENTIFIED_PRODUCTS')}</TableCell>
                            <TableCell align='center' className={classes.headCell}>{translate.i18n('SCRAPED_PRODUCTS')}</TableCell>
                            <TableCell align='center' className={classes.headCell}>{translate.i18n('HISTORY')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {catalogs.map((catalog, key) =>
                            <TableRow key={catalog.siteName} style={{ backgroundColor: key % 2 === 0 ? theme.palette.grey.semilight : theme.palette.white.main }}>
                                <TableCell component='th' scope='row'>
                                    {catalog.stats ? Facade.formatDate(new Date(catalog.stats.oldestDate)) : '-'}
                                </TableCell>
                                <TableCell align='center'>{catalog.stats ? catalog.stats.tag : '-'}</TableCell>
                                <TableCell align='center'>{catalog.siteName}</TableCell>
                                <TableCell align='center'>{catalog.accounts ? catalog.accounts.length < 2 ? catalog.accounts[0] ? catalog.accounts[0].name : '-' : <OnMousePopover text={translate.i18n('MULTIPLE_ACCOUNTS')} textClassName={classes.accountsText}>{catalog.accounts.map(a => <Typography key={a.name}>{a.name}</Typography>)}</OnMousePopover> : '-'}</TableCell>
                                <TableCell align='center'>{catalog.stats ? catalog.stats.categoryCount : '-'}</TableCell>
                                <TableCell align='center'>{catalog.stats ? catalog.stats.productCount : '-'}</TableCell>
                                <TableCell align='center'>{catalog.stats ? catalog.stats.scrapedDataCount : '-'}</TableCell>
                                <TableCell align='center' className={classes.moreCell} onClick={() => setDialogInfo({ open: true, currentCatalog: catalog })}>+</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            :
            <Paper className={classes.loaderContainer}><Loader size={50} /></Paper>
        }
        <Pagination page={page} count={Math.floor(CatalogStore.getCount() / rowsPerPage)} style={{ marginLeft: 'auto', marginTop: '10px' }} onChange={(e, p) => {
            const newParams = Object.assign({}, params);
            newParams.page = p;
            setParams(newParams);
        }} />
        <DialogCatalogInfo
            open={dialogInfo.open}
            handleClose={() => setDialogInfo({ open: false, currentCatalog: null })}
            catalog={dialogInfo.currentCatalog} />
    </div >;
};

export default CatalogPage;
